import styled from "styled-components";

export const MapWrapper = styled.div`
  height: 100vw;
  height: 100vh;
`;
